import { type ReactElement } from 'react';
import ImgDesktop from '../../assets/images/header.jpg';
import ImgMobile from '../../assets/images/header_responsive.jpg';
import { ReactComponent as Cgn } from '../../assets/images/cgn-logo-negativo.svg';
import { ReactComponent as Ctn } from '../../assets/images/ctn-logo-negativo.svg';
import { ReactComponent as CNValencia } from '../../assets/images/cnv-logo-negativo.svg';

const Header = (): ReactElement => (
	<header className="c-jt-header">
		<picture>
			<source srcSet={ImgMobile} media="(max-width: 768px)" />
			<img className="c-jt-header__img" src={ImgDesktop} alt="" />
		</picture>
		<div className="c-jt-header__wrap">
			<p className="c-jt-header__tagline">III JORNADAS TECNOLÓGICAS DEL NOTARIADO</p>
			<h1 className="[ c-jt-header__tit ] [ u-mt-8 ]">El valor del dato en la sociedad del siglo XXI</h1>
			<div className="[ c-jt-header__info c-jt-header__info--date ] [ u-mt-16 ]">
				<p>Lunes 27 de abril. De 10:00 a 13:30 h.</p>
				<p>Inscripción gratuita. Presencial y en streaming</p>
			</div>
			<div className="c-jt-header__info">
				<p>Colegio Notarial de Valencia</p>
				<p>c/ de Pascual i Genís, 21. 46002 Valencia</p>
			</div>
			<ul className="c-jt-header__footer">
				<li>
					<Cgn className="c-jt-header__logo" />
				</li>
				<li>
					<CNValencia />
				</li>
				<li>
					<Ctn className="c-jt-header__logo" />
				</li>
			</ul>
		</div>
	</header>
);

export default Header;
